module.exports = __webpack_public_path__ + "img/filter_icon.1a4423d4.svg";